import * as React from 'react'
import PropTypes from 'prop-types'

function mergeClasses(classes) {
  return Object.keys(classes)
    .filter((className) => classes[className])
    .reduce((acc, prev) => `${acc} ${prev}`, '')
}

export default function ZettleBar({
  content: { stickyNavButtons, logo, menu },
  isSticked,
  modelData,
}) {
  const [isOpen, setOpenState] = React.useState(false)
  const [isMobile, setMobileState] = React.useState(
    typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 1152px)').matches,
  )
  let pageURL = null
  if (modelData) {
    pageURL =
      Object.keys(modelData.query_string_params).length === 0
        ? modelData.pageURI
        : `${modelData.pageURI}?locale.x=${modelData.client_info.client_locale}`
  }

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const mql = window.matchMedia('(max-width: 1152px)')
      setMobileState(mql.matches)
      const listener = (event) => {
        if (mql.matches !== isMobile) {
          setMobileState(event.matches)
        }
      }

      mql.addEventListener('change', listener)

      return () => {
        mql.removeEventListener('change', listener)
      }
    }

    return () => null
  }, [isMobile])

  const onBarClick = React.useCallback(() => setOpenState((prev) => !prev), [])

  return (
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    <div
      className={mergeClasses({
        ztlnav: true,
        'ztlnav--sticked': isSticked,
        'ztlnav--opened': isOpen,
      })}
      onClick={onBarClick}
      onKeyDown={() => null}
      role="button"
    >
      <div className="ztlnav__content">
        <div className="ztlnav__logo-wrapper">
          <a
            href={logo.href}
            data-pa-click="zettle-cta-subnav|Logo"
            className="ztlnav__logo"
            pa-marked="1"
          >
            <svg
              width="156"
              height="24"
              viewBox="0 0 156 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M94.1108 0.747074L93.7423 3.12014H108.341L108.709 0.747074H94.1108ZM91.1771 16.6823L90.7949 19.0205H106.203L106.571 16.6823H91.1771ZM133.894 8.91244H138.243L138.981 6.82524H134.226L134.779 3.51565L131.939 3.91117L131.461 6.82422H125.453L126.006 3.51463L123.167 3.91014L122.688 6.82319H120.401L120.07 8.91039H122.355L121.323 15.0613C121.287 15.3851 121.249 15.673 121.249 15.9609C121.249 18.335 123.055 19.2705 125.23 19.2705C126.19 19.2705 127.479 19.0195 128.621 18.5154L128.991 16.212C127.701 16.8237 126.706 16.9682 125.968 16.9682C124.825 16.9682 123.905 16.464 124.089 15.3134L125.12 8.90936H131.128L130.097 15.0603C130.059 15.3841 130.022 15.672 130.022 15.9599C130.022 18.334 131.828 19.2695 134.005 19.2695C135.258 19.2695 136.548 19.0185 137.69 18.5143L138.059 16.211C136.768 16.8227 135.774 16.9671 134.741 16.9671C133.635 16.9671 132.678 16.463 132.861 15.3123L133.894 8.91244ZM142.062 0.747074L139.112 19.0205H141.84L144.863 0.351562L142.062 0.747074ZM118.611 13.4803C118.794 12.5089 118.906 11.7538 118.906 11.0703C118.906 8.55279 117.541 6.50248 114.334 6.50248C113.35 6.50248 112.427 6.71253 111.596 7.0896C109.128 8.20953 107.478 10.7998 107.478 13.7334C107.478 14.841 107.735 15.8441 108.218 16.6833C109.133 18.2715 110.865 19.2726 113.228 19.2726C114.704 19.2726 116.068 19.0215 117.283 18.3729L117.615 16.1075C116.25 16.7909 115.071 17.0061 113.854 17.0061C112.984 17.0061 112.213 16.8227 111.595 16.4784C110.615 15.9353 110.02 14.9896 110.02 13.7334V13.4803H118.611ZM111.596 9.69629C112.296 9.0272 113.163 8.62451 114.077 8.62451C115.883 8.62451 116.399 9.77518 116.399 10.8193C116.399 11.0703 116.399 11.4658 116.325 11.7907H110.28C110.561 10.9638 111.021 10.2414 111.596 9.69629ZM155.704 13.4803C155.89 12.5089 155.999 11.7538 155.999 11.0703C155.999 8.55279 154.636 6.50248 151.429 6.50248C147.522 6.50248 144.573 9.81207 144.573 13.7323C144.573 16.9333 146.71 19.2716 150.323 19.2716C151.797 19.2716 153.162 19.0205 154.378 18.3719L154.709 16.1064C153.346 16.7899 152.166 17.0051 150.95 17.0051C148.701 17.0051 147.116 15.7827 147.116 13.7323V13.4793H155.704V13.4803ZM151.171 8.62451C152.977 8.62451 153.494 9.77518 153.494 10.8193C153.494 11.0703 153.494 11.4658 153.42 11.7907H147.375C147.999 9.9545 149.511 8.62451 151.171 8.62451Z"
                fill="white"
              />
              <path
                d="M108.341 3.12109L94.71 16.6832H91.1777L104.808 3.12109H108.341Z"
                fill="#BCB0F7"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7 0.984375H5.06024C4.61429 0.984375 4.26744 1.32836 4.16834 1.72149L1.49264 18.3803C1.44309 18.7243 1.69084 19.0191 2.03769 19.0191H5.20889C5.65485 19.0191 6.05125 18.6751 6.1008 18.282L6.84405 13.8102C6.8936 13.3679 7.29 13.0731 7.73595 13.0731H9.81705C14.1775 13.0731 16.7045 11.0091 17.3487 6.93044C17.646 5.16136 17.3487 3.73627 16.5063 2.75345C15.5649 1.57407 13.9297 0.984375 11.7 0.984375ZM12.4432 7.07786C12.0964 9.38749 10.263 9.38749 8.52875 9.38749H7.53775L8.23145 5.06308C8.281 4.81738 8.52875 4.62081 8.7765 4.62081H9.22245C10.4116 4.62081 11.5513 4.62081 12.1459 5.30879C12.4928 5.65277 12.5919 6.24247 12.4432 7.07786ZM51.5877 0.984375H58.2274C60.4076 0.984375 62.0923 1.57407 63.0338 2.65517C63.8761 3.63799 64.1734 5.06308 63.8761 6.83216C63.232 10.9109 60.7049 12.9748 56.3445 12.9748H54.2634C53.8175 12.9748 53.4211 13.2696 53.3715 13.7119L52.6283 18.4294C52.5787 18.7243 52.2814 18.97 51.9841 18.97H48.5652C48.2183 18.97 47.9706 18.6751 48.0201 18.3312L50.6958 1.72149C50.7454 1.32836 51.1418 0.984375 51.5877 0.984375ZM55.0562 9.38749C56.7905 9.38749 58.6238 9.38749 58.9707 7.07786C59.1193 6.24247 59.0202 5.65277 58.6734 5.30879C58.0788 4.62081 56.9391 4.62081 55.7499 4.62081H55.304C55.0562 4.62081 54.8085 4.81738 54.7589 5.06308L54.0652 9.38749H55.0562ZM78.543 18.3803L81.1196 1.42664C81.1691 1.18094 81.3673 0.984375 81.5655 1.03352H84.489C84.7863 1.03352 85.034 1.32836 84.9845 1.67235L82.4574 18.282C82.4079 18.6751 82.061 19.0191 81.6151 19.0191H79.0385C78.7411 19.0191 78.4934 18.7243 78.543 18.3803ZM77.2547 7.02872H74.133C73.8853 7.02872 73.6375 7.22528 73.588 7.47099L73.4393 8.30639L73.2411 8.01154C72.5474 7.07786 71.0609 6.73387 69.5744 6.73387C66.1554 6.73387 63.1824 9.24007 62.6374 12.8274C62.3401 14.5964 62.786 16.2672 63.777 17.4466C64.7185 18.5277 66.1059 18.97 67.6915 18.97C70.4663 18.97 72.0024 17.2501 72.0024 17.2501L71.8537 18.0855C71.8042 18.3803 72.0519 18.6751 72.3988 18.6751H75.2231C75.6691 18.6751 76.0655 18.3803 76.115 17.938L77.7997 7.61841C77.8493 7.32357 77.6015 7.02872 77.2547 7.02872ZM72.9438 12.9256C72.6465 14.6456 71.2095 15.825 69.4257 15.825C68.5339 15.825 67.7906 15.5301 67.3447 14.9896C66.8987 14.449 66.7005 13.7119 66.8492 12.8765C67.1465 11.1566 68.5834 9.97718 70.3176 9.97718C71.2095 9.97718 71.9032 10.272 72.3987 10.8126C72.8447 11.304 73.0429 12.0902 72.9438 12.9256ZM44.3039 6.73387H47.4751C47.921 6.73387 48.1688 7.22528 47.921 7.56927L37.3669 22.2133C37.2182 22.459 36.9209 22.6064 36.6236 22.6064H33.4524C33.0065 22.6064 32.7092 22.115 32.9569 21.771L36.2272 17.2992L32.7092 7.42185C32.6101 7.07786 32.8578 6.73387 33.2542 6.73387H36.3759C36.7723 6.73387 37.1687 6.97958 37.2678 7.37271L39.1507 13.3188L43.5606 7.127C43.7093 6.8813 44.0066 6.73387 44.3039 6.73387ZM27.6055 7.02872H30.7272C31.074 7.02872 31.3218 7.32357 31.3218 7.61841L29.6371 17.938C29.5875 18.3803 29.1911 18.6751 28.7452 18.6751H25.9208C25.574 18.6751 25.3262 18.3803 25.3758 18.0855L25.5244 17.2501C25.5244 17.2501 23.9884 18.97 21.2136 18.97C19.628 18.97 18.2406 18.5277 17.2991 17.4466C16.3081 16.2672 15.8622 14.5964 16.1595 12.8274C16.7045 9.24007 19.6775 6.73387 23.0965 6.73387C24.583 6.73387 26.0695 7.07786 26.7632 8.01154L26.9118 8.30639L27.0605 7.47099C27.11 7.22528 27.3578 7.02872 27.6055 7.02872ZM22.8983 15.825C24.6821 15.825 26.119 14.6456 26.4163 12.9256C26.565 12.0902 26.3668 11.304 25.8713 10.8126C25.3758 10.272 24.6821 9.97718 23.7902 9.97718C22.0559 9.97718 20.619 11.1566 20.3217 12.8765C20.173 13.7119 20.3712 14.449 20.8172 14.9896C21.2631 15.5301 22.0064 15.825 22.8983 15.825Z"
                fill="white"
              />
            </svg>
          </a>
        </div>
        <div
          className={mergeClasses({
            ztlnav__indicator: true,
            'ztlnav__indicator--active': isOpen,
          })}
        />
        <div
          className={mergeClasses({
            'ztlnav__links-wrapper': true,
            'ztlnav__links-wrapper--active': isOpen,
          })}
          style={isMobile ? { height: isOpen ? menu.length * 54 + 24 : 0 } : {}}
        >
          {menu.map(({ href, text }) => (
            <a
              key={text}
              href={href}
              className={mergeClasses({
                ztlnav__link: true,
                'ztlnav__link--active': pageURL && href.endsWith(pageURL),
              })}
              data-pa-click={`{"link": "zettle-subnav-link|${text}","event_name":"zettle_sticky_nav_clicked"}`}
            >
              {text}
            </a>
          ))}
        </div>
        <div className="ztlnav__buttons-wrapper">
          {stickyNavButtons.map(({ text, href, color }) => (
            <a
              key={text}
              id="ul-btn"
              href={href}
              className={`pypl-btn mpp-btn pypl-btn--${color} pypl-btn--small`}
              role="button"
              pa-marked="1"
            >
              {text}
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}

ZettleBar.defaultProps = {
  modelData: '',
  isSticked: false,
}

ZettleBar.propTypes = {
  modelData: PropTypes.string,
  isSticked: PropTypes.bool,
  content: PropTypes.shape({
    stickyNavButtons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        href: PropTypes.string,
        color: PropTypes.string,
        fpti: PropTypes.shape({
          link: PropTypes.string,
          event_name: PropTypes.string,
        }),
      }),
    ),
    logo: PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
      color: PropTypes.string,
    }),
    menu: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.string,
      }),
    ),
  }).isRequired,
}
